import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-insurance-card',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './insurance-card.component.html',
})
export class InsuranceCardComponent implements OnInit {
    @Input() product: any = null;
    @Input() selectedLanguage: string = 'en';
    @Output() apply: EventEmitter<any> = new EventEmitter<any>();
    productSlug: string = '';

    ngOnInit(): void {
        this.productSlug = this.product.productName
            ?.replaceAll(' ', '_')
            .toLowerCase();
    }

    applyProduct() {
        this.apply.emit(this.product);
    }
}
